import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["ConnectedSite"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getConnectedSite: build.query<
        GetConnectedSiteApiResponse,
        GetConnectedSiteApiArg
      >({
        query: () => ({ url: `/ConnectedSite` }),
        providesTags: ["ConnectedSite"],
      }),
      postConnectedSite: build.mutation<
        PostConnectedSiteApiResponse,
        PostConnectedSiteApiArg
      >({
        query: (queryArg) => ({
          url: `/ConnectedSite`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ConnectedSite"],
      }),
      putConnectedSiteById: build.mutation<
        PutConnectedSiteByIdApiResponse,
        PutConnectedSiteByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ConnectedSite/${queryArg.id}`,
          method: "PUT",
          body: queryArg.connectedSiteDto,
        }),
        invalidatesTags: ["ConnectedSite"],
      }),
      deleteConnectedSiteById: build.mutation<
        DeleteConnectedSiteByIdApiResponse,
        DeleteConnectedSiteByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/ConnectedSite/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["ConnectedSite"],
      }),
      getConnectedSiteTyp: build.query<
        GetConnectedSiteTypApiResponse,
        GetConnectedSiteTypApiArg
      >({
        query: () => ({ url: `/ConnectedSite/Typ` }),
        providesTags: ["ConnectedSite"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as connectedSiteApi };
export type GetConnectedSiteApiResponse =
  /** status 200 OK */ ConnectedSiteDto[];
export type GetConnectedSiteApiArg = void;
export type PostConnectedSiteApiResponse = /** status 201 Created */ number;
export type PostConnectedSiteApiArg = ConnectedSiteDto;
export type PutConnectedSiteByIdApiResponse = /** status 200 OK */ void;
export type PutConnectedSiteByIdApiArg = {
  id: number;
  connectedSiteDto: ConnectedSiteDto;
};
export type DeleteConnectedSiteByIdApiResponse = unknown;
export type DeleteConnectedSiteByIdApiArg = number;
export type GetConnectedSiteTypApiResponse =
  /** status 200 OK */ ConnectedSiteTypeDto[];
export type GetConnectedSiteTypApiArg = void;
export type ConnectedSiteDto = {
  id: number;
  name: string;
  description?: string | null;
  isActive?: boolean | null;
  substation: string;
  type: number;
  comment?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type ConnectedSiteTypeDto = {
  id: number;
  name: string;
  comment?: string | null;
};
export const {
  useGetConnectedSiteQuery,
  useLazyGetConnectedSiteQuery,
  usePostConnectedSiteMutation,
  usePutConnectedSiteByIdMutation,
  useDeleteConnectedSiteByIdMutation,
  useGetConnectedSiteTypQuery,
  useLazyGetConnectedSiteTypQuery,
} = injectedRtkApi;
